<template>
  <div class="scene signup flex-r">
    <div class="section size-50" />

    <div id="step-container" class="size-40">
      <div class="signup-form-bg shadow-large">
        <h1>
          Выберите ваш тип организации
        </h1>

        <SelectProjectTypeStepItem
          v-for="projectType in projectTypes"
          :key="projectType.id"
          :project-type="projectType"
          :is-selected="projectType.id === selectedProjectType.id"
          @click.native="selectProjectType(projectType)"
        />

        <div class="signup-form-buttons flex-r">
          <div class="section txt-algn-r size-100">
            <div
              class="button primary"
              @click="doneProjectTypeSelect"
            >
              <div class="text">
                Следующий шаг
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section size-10" />
  </div>
</template>

<script>
import SelectProjectTypeStepItem from './SelectProjectTypeStepItem';

const PROJECT_TYPES = [
  {
    id: 1,
    name: 'Юридическое лицо',
    types: 'ООО, ЗАО, ОДО, и.д.',
    description: 'Вы сможете воспользоваться всеми решениями без ограничений. Возможна оплата через расчетный счет и корпоративными картами.'
  },
  {
    id: 2,
    name: 'Индивидуальный предприниматель',
    types: 'ИП',
    description: 'Вы сможете воспользоваться всеми решениями без ограничений. Возможна оплата через расчетный счет и корпоративными картами.'
  },
  {
    id: 3,
    name: 'Физическое лицо или ремелсенник',
    types: 'Физ. Лицо, Ремесленник',
    description: 'Вы сможете воспользоваться всеми решениями без ограничений. Возможна оплата через расчетный счет и корпоративными картами.'
  }
];

export default {
  name: 'SelectProjectTypeStep',
  components: {
    SelectProjectTypeStepItem
  },
  props: {
    selectedProjectTypeId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      projectTypes: PROJECT_TYPES,
      selectedProjectType: this.getSelectedProjectType()
    }
  },
  methods: {
    doneProjectTypeSelect() {
      this.$emit('selectProjectType', this.selectedProjectType);
    },
    selectProjectType(projectType) {
      this.selectedProjectType = projectType;
    },
    getSelectedProjectType() {
      if (this.selectedProjectTypeId) {
        return PROJECT_TYPES.find(({ id }) => id === this.selectedProjectTypeId);
      }

      return PROJECT_TYPES[0];
    }
  }
}
</script>
